import styles from "./toolbox-all-map-labels.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { MapLabel } from "PosterEditor/model/poster-project";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { useEditorUI } from "PosterEditor/use-editor-ui";
import { Element } from "PosterEditor/model/poster-types";
import { DeleteButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { UploadedPhotosSection } from "./uploaded-photos-section";
import { usePlatformSettings } from "BEDROCK/settings/use-platform-settings";
import { useRef } from "react";

interface ToolboxAllMapLabelsProps {}

export const ToolboxAllMapLabels = (props: ToolboxAllMapLabelsProps) => {
  const { settings } = usePlatformSettings();
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <MapLabelList />
        {settings?.iOSAppEnabled && <UploadedPhotosSection />}
      </div>
    </div>
  );
};

const MapLabelList = () => {
  const { project, deleteCoordinate } = usePosterProject();
  const { setEditingElement } = useEditorUI();
  const mapLabels = project.styledPoints
    .map((point) => point.label)
    .filter((label) => label !== undefined) as MapLabel[];

  const elementFromMapLabel = (label: MapLabel): Element => {
    return {
      type: "mapLabel",
      id: label.id,
      mapLabel: label,
    };
  };

  const removeMapLabel = (label: MapLabel) => {
    const coordinate = label.coordinate;
    deleteCoordinate(coordinate);
  };

  return (
    <div className={styles.labelList}>
      <div className={styles.listContent}>
        {mapLabels.map((label) => (
          <SingleMapLabel
            key={label.id}
            label={label}
            onClick={() => setEditingElement(elementFromMapLabel(label))}
            onClickDelete={() => {
              removeMapLabel(label);
            }}
          />
        ))}
      </div>
    </div>
  );
};

interface SingleMapLabelProps {
  label: MapLabel;
  onClick: () => void;
  onClickDelete: () => void;
}

const SingleMapLabel = (props: SingleMapLabelProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { imageCache } = usePosterProject();

  const styleDescription = props.label.style.showImage
    ? "Photo label"
    : "Text label";

  const imageElement = imageCache?.get(props.label.style.imageName ?? "");

  return (
    <div className={styles.item}>
      <button className={styles.itemButton} onClick={props.onClick}>
        <div className={styles.itemContentLeading}>
          {!props.label.style.showImage && (
            <div className={styles.labelIcon}>
              <UIIcon iconName={"MAP-LABEL"} size={22} variant="REGULAR" />
            </div>
          )}
          {props.label.style.showImage && imageElement && (
            <img
              src={imageElement.src}
              alt={props.label.text}
              className={styles.labelThumbnailImage}
            />
          )}
          <div className={styles.textContent}>
            <h3>{props.label.text}</h3>
            <span className={styles.labelPlaceText}>{styleDescription}</span>
          </div>
        </div>
      </button>
      <div className={styles.trailingControls}>
        <DeleteButton onClick={props.onClickDelete} />
      </div>
    </div>
  );
};
